// Endpoints. Every facade host reverse-proxies the backend (WebSocket included) under /api
// on its own origin, so deployed builds bake no host: they talk to whichever host served
// them. Local development overrides all three from .env.development.
const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || `${window.location.origin}/api`
const SOCKET_ENDPOINT = import.meta.env.VITE_SOCKET_ENDPOINT || window.location.origin
const SOCKET_PATH = import.meta.env.VITE_SOCKET_PATH || '/api/socket.io'

export const URLS = {
  BASE_URL: `${API_ENDPOINT}/api/v1`,
  SOCKET_URL: SOCKET_ENDPOINT,
  SOCKET_PATH: SOCKET_PATH,
}
